<template>
    <!-- 钱包 -->
    <div  class="person">
        <div class="wode">
            <div class="tit">
                我的钱包
            </div>
            <div class="yue">
                <div class="shang">
                    <div class="shang-z">
                        <div>账户余额(可用余额)</div>
                        <div class="qian">￥{{user_money}}</div>
                    </div>
                    <div class="shang-r">
                        <el-button @click="tixian('Withdrawal')">提现</el-button>
                        <el-button  @click="tixian('Recharge')" class="choongz">充值</el-button>
                    </div>
                </div>
                <div class="line"></div>
                <div class="xia">
                    <div>
                        总余额：<span class="zong">￥{{total_amount}}</span>
                    </div>
                    <div>
                        冻结余额：<span class="dong">￥{{freeze_money}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mingxi">
            <div class="tit">
                交易记录
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="流水明细" name="first">
                    <div class="yi">
                        <el-select clearable v-model="form.type" placeholder="交易类型">
                            <el-option label="用户余额" value="um"></el-option>
                        </el-select>
                        <el-input clearable v-model="form.sn"  placeholder="订单编号"></el-input>
                        <el-date-picker
                            clearable
                            value-format='yyyy-MM-dd'
                            v-model="form.date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        
                        
                    </div>
                    <div class="btns">
                        <el-button class="chongzhi" @click="lsmxReset">重置</el-button>
                        <el-button class="shaixuan" @click="lsmxSearch">筛选</el-button>
                    </div>
                    <!-- 表格 -->
                    <el-table
                        v-loading="loading"
                        :data="lsmxList"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f9f9f9' }"
                    >
                        <el-table-column prop="sn" label="充值单号"> </el-table-column>
                        <el-table-column prop="change_amount" label="交易金额"> </el-table-column>
                        <el-table-column prop="deal_status.desc" label="交易状态"> </el-table-column>
                        <el-table-column prop="type_desc" label="类型描述"> </el-table-column>
                        <el-table-column prop="change_amount_desc" label="变动金额描述"> </el-table-column>
                        <el-table-column prop="remark" label="备注"> </el-table-column>
                        <el-table-column prop="create_time" label="交易时间"> </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="transactionDetail(scope.row.id)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <el-pagination
                    @size-change="lsmxhandleSizeChange"
                    @current-change="lsmxhandleCurrentChange"
                    :current-page="params.page_no"
                    :page-sizes="[10, 15, 25, 50]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="lsmxtotal">
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="订单发票" name="second">
                    <div class="yi">
                        <el-input v-model="ddfpForm.source_sn"  placeholder="订单编号"></el-input>
                        <el-select v-model="ddfpForm.invoice_status" placeholder="开票状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待开票" value="1"></el-option>
                            <el-option label="开票中" value="2"></el-option>
                            <el-option label="已开票" value="3"></el-option>
                            <el-option label="已驳回" value="4"></el-option>
                        </el-select>
                        <el-date-picker
                            value-format='yyyy-MM-dd'
                            v-model="ddfpForm.date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        
                        
                    </div>
                    <div class="btns">
                        <el-button class="chongzhi" @click="ddfpReset">重置</el-button>
                        <el-button class="shaixuan" @click="ddfpSearch">筛选</el-button>
                    </div>
                    <!-- 表格 -->
                    <el-table
                        v-loading="loading"
                        :data="ddfpList"
                        style="width: 100%"
                        :header-cell-style="{ background: '#f9f9f9' }"
                    >
                        <el-table-column prop="source_sn" label="订单编号"> </el-table-column>
                        <el-table-column prop="mu" label="交易类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.change_type == 103">开通会员</span>
                                <span v-if="scope.row.change_type == 104">上线发布舱位</span>
                                <span v-if="scope.row.change_type == 105">订舱服务费扣除</span>
                                <span v-if="scope.row.change_type == 106">订舱亏舱费扣除</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="change_amount" label="交易金额"> </el-table-column>
                        <el-table-column prop="create_time" label="交易时间"> </el-table-column>
                        <el-table-column prop="from_type" label="交易渠道">
                            <template slot-scope="scope">
                                <span v-if="scope.row.from_type == 1">SPOT订单</span>
                                <span v-if="scope.row.from_type == 2">会员</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="invoice_status" label="开票状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.invoice_status == 0">不可开票订单</span>
                                <span v-if="scope.row.invoice_status == 1">待开票</span>
                                <span v-if="scope.row.invoice_status == 2">开票中</span>
                                <span v-if="scope.row.invoice_status == 3">已开票</span>
                                <span v-if="scope.row.invoice_status == 4">已驳回</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <!-- <el-button type="text" @click="transactionDetail('Invoicing')">详情</el-button> -->
                                <el-button type="text" @click="transactionDetail(scope.row.account_log_id)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                    @size-change="ddfphandleSizeChange"
                    @current-change="ddfphandleCurrentChange"
                    :current-page="ddfpParams.page_no"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="ddfptotal">
                    </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
    
<script>
import { accountLogLists,orderFapiaolists } from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            activeName: 'first',
            form:{
                type:'',
                sn:'',
                date:[],
            },
            ddfpForm:{
                source_sn:'',
                invoice_status:'',
                date:[],
            },
            headers:{
                'token':localStorage.getItem('token')
            },
            // 可用余额
            user_money:JSON.parse(localStorage.getItem('userInfo')).user_money,
            // 冻结金额
            freeze_money:JSON.parse(localStorage.getItem('userInfo')).freeze_money,
            // 总余额
            total_amount:JSON.parse(localStorage.getItem('userInfo')).total_amount,
            // 流水明细列表
            lsmxList:[],
            lsmxcurrentPage:1,
            lsmxtotal:0,
            params:{
                page_no:1,
                page_size:10,
                type:'um',//流水明细类型 um-用户余额
            },
             // 订单发票列表
            ddfpList: [],
            ddfpcurrentPage: 1,
            ddfptotal: 0,
            ddfpParams: {
                page_no: 1,
                page_size: 10,
                source_sn: "", 
                state_time: "", 
                end_time: "", 
                invoice_status: "", 
            },
            loading:false,
        }
    },
    methods: {
        handleClick() {
            if(this.activeName == 'first'){
               this.getWalleList() 
            }else if(this.activeName == 'second'){
               this.getDDFPWalleList()
            }
        },
        tixian(ind){
            this.$router.push('/'+ind)
        },
        // 流水记录详情
        transactionDetail(ind){
            if(this.activeName == 'first'){
               this.$router.push({
                    name:'Transaction',
                    query:{
                        id:ind
                    }
                })
            }else if(this.activeName == 'second'){
                console.log(11111,ind);
            //    this.$router.push({
            //         name:'Invoicing',
            //         query:{
            //             id:ind
            //         }
            //     })
                this.$router.push({
                    name:'Invoicing',
                    query:{
                        id:ind
                    }
                })
            }
            
        },
        
        // 获取流水记录列表数据
        async getWalleList(e){
            this.loading = true
            try {
                const res = await accountLogLists(e,this.headers)
                if(res.code==1){
                    this.loading = false
                    this.lsmxList=res.data.lists
                    this.lsmxtotal=res.data.count
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 流水记录分页
        lsmxhandleSizeChange(val) {
            this.params.page_size=val
            this.getWalleList(this.params)
        },
        lsmxhandleCurrentChange(val) {
            this.params.page_no=val
            this.getWalleList(this.params)
        },
        // 流水记录搜索
        async lsmxSearch(){
            this.params.page_no=1
            this.params.page_size=10
            this.params.type=this.form.type
            this.params.sn=this.form.sn
            if(this.form.date.length>0){
                this.params.state_time=this.form.date[0]
                this.params.end_time=this.form.date[1]
            }
            
            // const res = await 
            this.getWalleList(this.params)
        },
        // 重置
        async lsmxReset(){
            this.params={
                page_no:1,
                page_size:10,
                type:'um',
            }
            this.form={
                type:'',
                sn:'',
                date:[],
            }
            this.getWalleList(this.params)
        },
        // 获取流水记录列表数据
        async getDDFPWalleList() {
            this.loading = true
            try {
                const res = await orderFapiaolists(this.ddfpParams, this.headers);
                if(res.code==1){
                    this.loading = false
                    this.ddfpList=res.data.lists
                    this.ddfptotal=res.data.count
                }
            } catch (error) {
                console.log(error,"获取列表失败");
            }
        },
        // 订单发票分页
        ddfphandleSizeChange(val) {
            this.ddfpParams.page_size = val;
            this.getDDFPWalleList();
        },
        ddfphandleCurrentChange(val) {
            this.ddfpParams.page_no = val;
            this.getDDFPWalleList();
        },
        // 订单发票搜索
        async ddfpSearch() {
            this.ddfpParams.page_no = 1;
            this.ddfpParams.page_size = 10;
            this.ddfpParams.source_sn = this.ddfpForm.source_sn;
            this.ddfpParams.invoice_status = this.ddfpForm.invoice_status;
            
            if(this.ddfpForm.date.length>0){
                this.ddfpParams.state_time = this.ddfpForm.date[0];
                this.ddfpParams.end_time = this.ddfpForm.date[1];
            }
            
            this.getDDFPWalleList();
        },
        // 重置
        async ddfpReset() {
            this.ddfpParams = {
                page_no: 1,
                page_size: 10,
                source_sn: "", 
                state_time: "", 
                end_time: "", 
                invoice_status: "", 
            };
            this.ddfpForm = {
                source_sn:'',
                invoice_status:'',
                date:[],
            };
            this.getDDFPWalleList();
        },
    },
    mounted(){
        this.getWalleList(this.params)
    }
}
</script>
    
<style style lang="scss" scoped>
.person{
    background: #f9f9f9;
    height: 100%;
}
::v-deep .el-tabs__item.is-active {
    color: #0073F5;//选中
}

::v-deep .el-tabs__item:hover {
    color: #0073F5;//hover
    // cursor: pointer;
}
// 普通字体颜色
::v-deep .el-tabs__item {
    color: #606260;//悬浮
    // cursor: pointer;
    font-size: 18px;
}

// 下划线颜色
::v-deep .el-tabs__active-bar {
    background-color: #0073F5;
}

.tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
}
.wode{
    width: 976px;
    height: 316px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 32px;
    box-sizing: border-box;

    .yue{
        margin-top: 24px;
        width: 912px;
        height: 203px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        padding: 32px 32px 24px 32px;
        box-sizing: border-box;

        .shang{
            display: flex;
            align-items: center;
            justify-content: space-between;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            .qian{
                font-size: 36px;
                color: #333333;
                font-weight: bold;
            }

            .shang-r{
                .el-button{
                    width: 120px;
                    height: 48px;
                    border-radius: 8px 8px 8px 8px;
                    border: 2px solid #0073F5;
                    color: #0073F5;
                    background: #FFFFFF;
                }
                .choongz{
                    border: 0;
                    background: #0073F5;
                    color: #FFFFFF;
                }
            }
        }

        .line{
            width: 848px;
            height: 1px;
            background: #DDDDDD;

            margin: 24px 0;
        }
        .xia{
            display: flex;
            align-items: center;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            font-style: normal;
            text-transform: none;

            div{
                margin-right: 152px;
            }
            .zong{
                color: #0073F5;
            }

            .dong{
                color: #FE3300;
            }
        }
    }
}

.mingxi{
    width: 976px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;

    margin-top: 20px;
    padding: 32px 32px 24px 32px;
    box-sizing: border-box;

    .el-tabs{
        margin-top: 14px;
    }
}

.yi{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        margin-top: 4px;

        :deep(.el-input){
            width: 296px;
            height: 40px;
            margin-bottom: 16px;

            input{
                width: 296px;
                height: 40px;
                background: #F9F9F9;
                border-radius: 8px 8px 8px 8px;

                border: 0;
            }
        }
        :deep(.el-date-editor){
            width: 296px;
            height: 40px;
            background: #F9F9F9 ;
            border-radius: 8px 8px 8px 8px;
            border: 0;
            margin-bottom: 16px;

            .el-range-input{
                background: #f9f9f9 ;
            }
        }
    }

.btns{
    // width: 360px;
    height: 40px;
    text-align: right;
    margin-bottom: 16px;
    .chongzhi{
        width: 100px;
        height: 40px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    }

    .shaixuan{
        width: 100px;
        height: 40px;
        background: #0073F5;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        font-style: normal;
        text-transform: none;
    }
}
    

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-top: 4px;

    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    
    }
    .first{
        padding-left: 24px;
        // width: 320px;
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }
}

.el-pagination{
    text-align: right;
    margin-top: 80px;
}

.zanwu{
    text-align: center;
}
</style>